import { TFunction } from "i18next";

/** How long until the next play, in days past a day, else hours and minutes; each unit agrees with its number. */
export const nextPlayLabel = (
  t: TFunction,
  dateStr: string,
  now = Date.now()
): string => {
  const diff = new Date(dateStr).getTime() - now;

  if (diff <= 0) return t("games.overlay.now") as string;

  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

  if (hours > 24) {
    const days = Math.floor(hours / 24);
    return `${days} ${t("games.overlay.days", { count: days })}`;
  }

  if (hours > 0) {
    return `${hours} ${t("games.overlay.hours", {
      count: hours,
    })} ${minutes} ${t("games.overlay.minutes", { count: minutes })}`;
  }

  return `${minutes} ${t("games.overlay.minutes", { count: minutes })}`;
};
